export * from './chart.directive';
export * from './color.service';
export * from './colors.service';
export * from './chart.module';



// WEBPACK FOOTER //
// ./src/app/typescripts/free/charts/index.ts